import { ICountry, IPhysicalStore, IRegisterFieldsData, IState, RootState } from '@checkout/state';
import { FormikProps } from 'formik';
import { Field } from 'formik';
import * as React from 'react';
import { Fragment } from 'react';
import { ChangeEvent } from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { NewsletterCheckbox } from '..';
import { ICheckoutContextConfig } from './../../../config/contextCheckoutConfig.d';
import messages from './../../../i18n/base-en';
import { getOptionsData } from './../../../utils/address';
import { DropDownField, InputField, Section } from './../../presentational';
import * as Styles from './RegisterCustomerClubFields.scss';

interface IOwnProps {
  formikContext?: FormikProps<IRegisterFieldsData>; // This is injected from RegisterFormWizard
  checkoutContextConfig: ICheckoutContextConfig;
  physicalStores?: IPhysicalStore[];
}

interface IConnectedProps {
  countries: ICountry[];
}

interface IConnectetDispatchProps {}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedIntlProps;

class RegisterCustomerClubFields extends React.Component<Props, {}> {

  render() {
    const { intl, countries, formikContext, physicalStores, checkoutContextConfig } = this.props;
    const { formatMessage } = intl;
    const countryOptions = getOptionsData('Country', countries, null);
    let stateOptions: ICountry[] | IState[] | undefined = undefined;

    if (formikContext) {
      stateOptions = getOptionsData('State', countries, formikContext.values.register.country);
    }

    return (
      <Fragment>
        <Section>
          <Field
            id="register.address1"
            name="register.address1"
            component={InputField}
            placeholder={formatMessage(messages.membership_address1_placeholder)}
            label={formatMessage(messages.membership_address1_label)}
            required={true}
            sizeVariant="half"
            type="text"
            submitOnEnter={true}
          />
          <Field
            id="register.city"
            name="register.city"
            component={InputField}
            placeholder={formatMessage(messages.membership_city_placeholder)}
            label={formatMessage(messages.membership_city_label)}
            required={true}
            sizeVariant="half"
            type="text"
            submitOnEnter={true}
          />
          <Field
            id="register.zipCode"
            name="register.zipCode"
            component={InputField}
            placeholder={formatMessage(messages.membership_zipcode_placeholder)}
            label={formatMessage(messages.membership_zipcode_label)}
            required={true}
            sizeVariant="half"
            type="text"
            submitOnEnter={true}
          />
          <Field
            id="register.phoneNumber"
            name="register.phoneNumber"
            component={InputField}
            placeholder={formatMessage(messages.membership_phone_placeholder)}
            label={formatMessage(messages.membership_phone_label)}
            required={true}
            sizeVariant="half"
            type="text"
            submitOnEnter={true}
          />
          <Field
            id="register.country"
            name="register.country"
            component={DropDownField}
            placeholder={formatMessage(messages.membership_country_placeholder)}
            label={formatMessage(messages.membership_country_label)}
            required={true}
            sizeVariant="half"
            options={countryOptions}
            valueSelector={(item: ICountry) => item.country}
            type="select"
            onChange={(event: ChangeEvent<any>) => {
              if (stateOptions && formikContext) {
                formikContext.setFieldValue('register.state', '');
              }
            }}
          />
          {stateOptions && (
            <Field
              id="register.state"
              name="register.state"
              component={DropDownField}
              placeholder={formatMessage(messages.membership_state_placeholder)}
              label={formatMessage(messages.membership_state_label)}
              required={true}
              sizeVariant="half"
              options={stateOptions}
              valueSelector={(item: IState) => item.state}
              type="select"
            />
          )}
          {formikContext && formikContext.values.register.country === 'SE' && (
            <Field
              id="register.identityNumber"
              name="register.identityNumber"
              component={InputField}
              placeholder={formatMessage(messages.membership_identity_number_placeholder)}
              label={formatMessage(messages.membership_identity_number_label)}
              required={true}
              type="text"
              sizeVariant="half"
              submitOnEnter={true}
            />
          )}
          {physicalStores && (
            <Field
              id="register.physicalStore"
              name="register.physicalStore"
              component={DropDownField}
              placeholder={formatMessage(messages.membership_physical_store_placeholder)}
              label={formatMessage(messages.membership_physical_store_label)}
              required={true}
              options={physicalStores}
              valueSelector={(item: IPhysicalStore) => item.store}
              type="select"
            />
          )}
          <div className={Styles.newsletter}>
            <NewsletterCheckbox
              id="register.newsletter"
              name="register.newsletter"
              checkoutContextConfig={checkoutContextConfig}
            />
          </div>
        </Section>
      </Fragment>
    );
  }
}

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    (state: RootState) => ({
      countries: state.checkout.countries,
    }),
    {}
  )
)(RegisterCustomerClubFields);
